var map = {
	"./eftgt": 14,
	"./eftgt.json": 14,
	"./generator.py": 100,
	"./map1": 15,
	"./map1.json": 15,
	"./map2": 16,
	"./map2.json": 16,
	"./map3": 17,
	"./map3.json": 17,
	"./map4": 18,
	"./map4.json": 18,
	"./map5": 19,
	"./map5.json": 19,
	"./map6": 20,
	"./map6.json": 20,
	"./map_list": 8,
	"./map_list.json": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;


//////////////////
// WEBPACK FOOTER
// ./src/game/maps ^\.\/.*$
// module id = 99
// module chunks = 0